module.exports = function (app, mod) {
  return "\n\t<div id=\"chat-sidebar\" class=\"chat-sidebar\">\n    \t<div class=\"saito-modal-content hide-scrollbar\"></div>\n    </div>";
};